import { useEffect, useState } from "react";

export interface MyWindow extends Window {
  x?: number;
}

export const useWindowResize = () => {
  const [coordinates, setCoordinates] = useState({ x: window.innerWidth, y: window.innerHeight });

  useEffect(() => {
    const handleResize = () => {
      setCoordinates({ x: window.innerWidth, y: window.innerHeight });
    }

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, []);

  return coordinates;
}